<div class="TotemWidget TotemWidgetDetails card">
    <div class="card-body">
        <div class="TotemWidgetDetails-List" role="list">
            @for (item of detailList; track item; let i = $index) {
                <div class="TotemWidgetDetails-List-Item {{ i > 0 ? 'border-top' : '' }}" role="listitem">
                    @if (item.link) {
                        <button type="button" class="btn btn-block d-flex text-start" (click)="checkGoToLink(item)" [attr.aria-label]="item.title + ' ' + ('totem-a11y.opens-new-window' | locTranslate)">
                            <div>
                                <i class="fa-regular fa-fw fa-lg text-primary {{item.icon}} me-3" aria-hidden="true"></i>
                            </div>
                            <div>
                                <h5 class="mb-2">{{ item.title }}</h5>
                                @if (item.subtitle) {
                                    <div class="text-muted">{{ item.subtitle }}</div>
                                }
                                @if (item.date) {
                                    <div class="text-muted small">{{ item.date | locFormat:'date' }}</div>
                                }
                                @else if (item.description) {
                                    <div class="text-muted small">{{ item.description }}</div>
                                }
                            </div>
                            <div>
                                <i class="fa-regular fa-chevron-right" aria-hidden="true"></i>
                            </div>
                        </button>
                    }
                    @else {
                        <div class="btn btn-block d-flex text-start pe-none">
                            <div>
                                <i class="fa-regular fa-fw fa-lg text-primary {{item.icon}} me-3" aria-hidden="true"></i>
                            </div>
                            <div>
                                <h5 class="mb-2">{{ item.title }}</h5>
                                @if (item.subtitle) {
                                    <div class="text-muted">{{ item.subtitle }}</div>
                                }
                                @if (item.date) {
                                    <div class="text-muted small">{{ item.date | locFormat:'date' }}</div>
                                }
                                @else if (item.description) {
                                    <div class="text-muted small">{{ item.description }}</div>
                                }
                            </div>
                        </div>
                    }
                </div>
            }
        </div>
    </div>
</div>
